import { FC, useContext } from 'react';

import { useApolloClient } from '@apollo/client';
import { H2, Modal } from '@smartshell/ui-kit';

import { Comments } from 'components/Comments';
import { LocalizationContext } from 'localization';

import { HOST, IHostResponse } from '../HostMessageModal/schema';
import s from './HostCommentsModal.module.scss';

interface IHostCommentsModalProps {
  onClose: (arg: boolean) => void;
  hostId: number;
}

export const HostCommentsModal: FC<IHostCommentsModalProps> = ({
  onClose,
  hostId,
}) => {
  const { t } = useContext(LocalizationContext);

  const apolloClient = useApolloClient();

  const titleHost =
    apolloClient.cache.readQuery<IHostResponse>({
      query: HOST,
      variables: { id: hostId },
    })?.hostOverview.alias ?? '';

  return (
    <Modal onClose={() => onClose(false)} className={s.root}>
      <div className={s.header}>
        <H2>{t('host.ctx.note')}</H2>
        <span className={s.title}>{titleHost}</span>
      </div>
      <Comments entityId={hostId} type={'HOST'} />
    </Modal>
  );
};
